import { AgDialog, domainCodeAtom } from '@australiangreens/ag-internal-components';
import { Box, Link, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { environment } from '@/config';
import { createBaseContactUrl } from '@/util';

function ProfileNotDisplayingModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const domainCode = useAtomValue(domainCodeAtom);
  const isDev = ['test', 'local', 'dev'].includes(environment);
  return (
    <AgDialog
      isOpen={isOpen}
      dialogTitle="Profile not displaying?"
      onClose={onClose}
      maxWidth="md"
      secondaryButton={{ text: 'Close' }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem"
        }}>
        <Typography>
          If you are not seeing the profile for the person you are trying to contact, you are likely
          not logged into Rocket.
        </Typography>
        <Box>
          <Typography>Please follow these steps:</Typography>
          <ol
            style={{
              listStyleType: 'disc',
              paddingLeft: '1rem',
              listStylePosition: 'inside',
              marginBlockStart: 0,
            }}
          >
            <li>
              Log in to{' '}
              <Link
                target="_blank"
                rel="noreferrer"
                href={`https://${createBaseContactUrl(domainCode, isDev)}`}
              >
                Rocket
              </Link>
            </li>
            <li>Return to this page and refresh</li>
          </ol>
        </Box>
      </Box>
    </AgDialog>
  );
}

export default function ProfileNotDisplayingButton({
  contactName,
  contactId,
}: {
  contactName?: string;
  contactId?: number;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <button className="textButton" onClick={() => setIsModalOpen(true)}>
        Profile not displaying above?
      </button>
      {contactName && contactId && (
        <>
          <br />
          <i>
            {contactName} - {contactId}.
          </i>
        </>
      )}
      <ProfileNotDisplayingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
